<a>
    <div class="mb-4 d-flex justify-content-center align-items-center image-wrapper">
        <img [src]="avatarImage" [alt]="avatarAltText" />
    </div>
    <h6 class="text-center" *ngIf="avatarTitle" [ngStyle]="titleColor ? { color: titleColor } : {}">
        {{ avatarTitle }}
    </h6>
</a>
